import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// "ResizeObserver loop ..." is a benign browser notice (some UI libs trigger it
// on layout changes), but the dev error overlay surfaces it as a red error.
// Swallow only that specific message so it doesn't interrupt the UI. Registered
// before render so it runs ahead of the overlay's own error handler.
const RESIZE_OBSERVER_ERR = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (e) => {
  if (e?.message && RESIZE_OBSERVER_ERR.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
